import { ReactComponent as Icon } from '../../assets/icons/publicIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
